import React, { useContext } from 'react';
import { Button } from '@material-ui/core';
import { NavHashLink as NavLink } from 'react-router-hash-link';
import { makeStyles } from '@material-ui/core/styles';
import './Landing.css';
import { ThemeContext } from '../../contexts/ThemeContext';
import { headerData } from '../../data/headerData';

function Landing() {
    const { theme, drawerOpen } = useContext(ThemeContext);

    const useStyles = makeStyles((t) => ({
        resumeBtn: {
            color: theme.primary,
            borderRadius: '999px',
            textTransform: 'inherit',
            textDecoration: 'none',
            width: '160px',
            fontSize: '1rem',
            fontWeight: '600',
            height: '50px',
            fontFamily: 'var(--primaryFont)',
            border: `2px solid ${theme.primary}`,
            transition: 'all 0.2s ease-out',
            '&:hover': {
                backgroundColor: theme.primary,
                color: theme.secondary,
                transform: 'translateY(-2px)',
            },
            [t.breakpoints.down('sm')]: {
                width: '180px',
            },
        },
        contactBtn: {
            backgroundColor: theme.primary,
            color: theme.secondary,
            borderRadius: '999px',
            textTransform: 'inherit',
            textDecoration: 'none',
            width: '150px',
            height: '50px',
            fontSize: '1rem',
            fontWeight: '600',
            fontFamily: 'var(--primaryFont)',
            border: `2px solid ${theme.primary}`,
            transition: 'all 0.2s ease-out',
            '&:hover': {
                backgroundColor: 'transparent',
                color: theme.primary,
                transform: 'translateY(-2px)',
            },
            [t.breakpoints.down('md')]: {
                width: '140px',
            },
        },
    }));

    const classes = useStyles();

    return (
        <div className='landing' id='home'>
            <div className='landing-shell'>
                <div className='landing-card'>
                    <div className='landing-copy' style={{ color: theme.tertiary }}>
                        <p className='eyebrow'>Java Full Stack Engineer • enterprise software & cloud platforms</p>
                        <h1>{headerData.name}</h1>
                        <h2>{headerData.title}</h2>
                        <p className='lead'>{headerData.description}</p>

                        <div className='chip-row'>
                            {headerData.highlights?.map((item) => (
                                <span key={item}>{item}</span>
                            ))}
                        </div>

                        <div className='lcr-buttonContainer'>
                            {headerData.resumePdf && (
                                <a href={headerData.resumePdf} target='_blank' rel='noreferrer'>
                                    <Button className={classes.resumeBtn}>Download CV</Button>
                                </a>
                            )}
                            <NavLink to='/#contacts' smooth={true} spy='true' duration={2000}>
                                <Button className={classes.contactBtn}>Contact</Button>
                            </NavLink>
                        </div>
                    </div>

                    <div className='landing-visual'>
                        <div className='portrait-frame'>
                            <img
                                src={headerData.image}
                                alt={headerData.name}
                                className='landing--img'
                                style={{
                                    opacity: `${drawerOpen ? '0' : '1'}`,
                                    borderColor: theme.primary,
                                }}
                            />
                        </div>
                        <div className='floating-card' style={{ background: theme.primary30, color: theme.tertiary }}>
                            <div>
                                <strong>Based in</strong>
                                <span>{headerData.location}</span>
                            </div>
                            <div>
                                <strong>Specializing in</strong>
                                <span>Modern web apps, APIs, and cloud delivery</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Landing;
